import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/(protected)/settings/page.tsx");
